export const errorMessage = Object.freeze({
	DIRECT_TUNNEL_DISABLED: "Please contact the administrator to enable the direct tunnel.",
	DEVICE_NOT_FOUND: "Device does not exist. Please check that device has been registered correctly.",
	BAD_REQUEST: "Add Subnet Mapping failed. Please make sure that the subnet is correct.",
	ADD_SUBNET_MAPPING_PEER_NOT_FOUND: "Add Subnet Mapping failed, please make sure that the device is setup for direct tunnel.",
	SERVICE_STATUS_PEER_NOT_FOUND: "Please try to update the device firmware.",
	ALREADY_EXIST: "Subnet Mapping already exist.",
	NOT_ALLOWED_REMOVE: "Remove Subnet Mapping failed.",
	UNKNOWN_ERROR: "Unknown error, please contact the administrator.",
	ROUTE_NOT_FOUND: "Subnet Mapping not found. Will auto refresh the page."
})

export const timeBasedAccessMode = {
	permanent: "Permanent",
	scheduled: "Scheduled"
}

export const initialState = {
	/** open modal */
	addSubnetMappingModal: false,

	/** choose the user with peers */
	userMappings: null, // the user mappings data
	userOptions: [], // for the select dropdown options
	isNotChooseUser: false,
	peers: null,

	/** subnet input */
	address: "",
	prefix: "",
	isNotInputAddress: false,
	isNotInputPrefix: false,
	isNotValidatedAddress: false,
	isNotValidatedPrefix: false,

	/** time-based access */
	mode: "scheduled",
	isNotInputTimeBase: false,
	isNotValidatedTimeRange: false,

	/** request */
	requestData: null
}

export const reducer = (state, action) => {
	switch (action.type) {
		/** Open modal */
		case "OPEN_ADD_SUBNET_MAPPING_MODAL": {
			return {
				...state,
				addSubnetMappingModal: true
			}
		}
		/** Choose user */
		case "IS_NOT_CHOOSE_USER": {
			return {
				...state,
				isNotChooseUser: true
			}
		}
		/** Input subnet */
		case "IS_NOT_INPUT_ADDRESS": {
			return {
				...state,
				isNotInputAddress: true
			}
		}
		case "IS_NOT_INPUT_PREFIX": {
			return {
				...state,
				isNotInputPrefix: true
			}
		}
		/** Input validation */
		case "IS_NOT_VALIDATED_ADDRESS": {
			return {
				...state,
				isNotValidatedAddress: action.payload
			}
		}
		case "IS_NOT_VALIDATED_PREFIX": {
			return {
				...state,
				isNotValidatedPrefix: action.payload
			}
		}
		/** Time-based access */
		case "IS_NOT_INPUT_TIME_BASE": {
			return {
				...state,
				isNotInputTimeBase: true
			}
		}
		case "IS_NOT_VALIDATED_TIME_RANGE": {
			return {
				...state,
				inNotInputTimeBase: false,
				isNotValidatedTimeRange: action.payload
			}
		}
		/** Handlers */
		case "HANDLE_ON_USER_CHANGE": {
			return {
				...state,
				isNotChooseUser: false,
				peers: action.payload.peers,
				requestData: {
					...state.requestData,
					user_peer_col: [action.payload.user]
				}
			}
		}
		case "HANDLE_INPUT_ADDRESS": {
			return {
				...state,
				address: action.payload,
				isNotInputAddress: false
			}
		}
		case "HANDLE_INPUT_PREFIX": {
			return {
				...state,
				prefix: action.payload,
				isNotInputPrefix: false
			}
		}
		/** handle input reason */
		case "HANDLE_INPUT_REASON": {
			return {
				...state,
				requestData: {
					...state.requestData,
					reason: action.payload
				}
			}
		}
		/**  handle set time base */
		case "HANDLE_SWITCH_MODE": {
			return {
				...state,
				mode: action.payload,
				requestData: {
					...state.requestData,
					mode: timeBasedAccessMode[action.payload]
				}
			}
		}
		case "HANDLE_SET_TIME_BASE": {
			return {
				...state,
				isNotInputTimeBase: false,
				requestData: {
					...state.requestData,
					activated_time: action.payload[0],
					deactivated_time: action.payload[1]
				}
			}
		}
		/** Fetch user mappings */
		case "GET_USER_MAPPINGS": {
			return {
				...state,
				userMappings: action.payload.userMappings,
				userOptions: action.payload.userOptions
			}
		}
		/** Reset all states */
		case "RESET_All": {
			return {
				...initialState,
				userMappings: state.userMappings,
				userOptions: state.userOptions
			}
		}
		default:
			return state
	}
}
